export const MAIN_FONT_COLOR = '#3f3f3f';

export const MAIN_ORANGE = '#ffa700';
export const GRAY_76 = '#767676';
export const GRAY_DE = '#dedede';
export const GRAY_F4 = '#f4f4f4';
export const DARK_BG = '#282c34';
export const LINK_BLUE = '#0f5485';
export const RED = '#d50000';
